import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlanner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.31114 0.833008H13.7526C14.8877 0.833008 15.8337 1.75835 15.8337 2.79936V17.2C15.8337 18.2988 14.8877 19.1663 13.7526 19.1663H6.31114C5.11294 19.1663 4.16699 18.2988 4.16699 17.2V2.79936C4.16699 1.75835 5.11294 0.833008 6.31114 0.833008ZM10.0319 16.3903C10.5994 16.3903 11.0409 16.853 11.0409 17.3735C11.0409 17.894 10.5994 18.3567 10.0319 18.3567C9.40123 18.3567 8.95978 17.894 8.95978 17.3735C8.95978 16.853 9.40123 16.3903 10.0319 16.3903ZM6.31114 3.08853H13.7526C14.0679 3.08853 14.3201 3.3777 14.3201 3.66687V15.0023C14.3201 15.2915 14.0679 15.5228 13.7526 15.5228H6.31114C5.93276 15.5228 5.68051 15.2915 5.68051 15.0023V3.66687C5.68051 3.3777 5.93276 3.08853 6.31114 3.08853ZM9.02285 1.75835H11.167C11.5454 1.75835 11.5454 2.27885 11.167 2.27885H9.02285C8.58141 2.27885 8.58141 1.75835 9.02285 1.75835Z",
		fill: "currentColor"
	})
});
export default SvgPlanner;
